/**
 * Generic application event tracking
 *
 * Pushes domain events to GTM's dataLayer. GTM handles routing these
 * events to specific tracking tools (LinkedIn, GA4, Facebook, etc.).
 */

import { pushEvent } from "./dataLayer";

export type ApplicationType = "veteran" | "spouse" | "mentor";

export interface ApplicationStartedEventData {
  applicationType?: ApplicationType;
  applicationId?: string;
}

export interface ApplicationSubmittedEventData {
  applicationType?: ApplicationType;
  applicationId?: string;
}

/**
 * Track when a user starts an application
 * (after initial form submission but before survey completion)
 */
export function trackApplicationStarted(
  data: ApplicationStartedEventData = {},
): void {
  pushEvent("application_started", {
    application_type: data.applicationType,
    application_id: data.applicationId,
  });
}

/**
 * Track when a user completes their application
 * (after survey submission)
 */
export function trackApplicationSubmitted(
  data: ApplicationSubmittedEventData = {},
): void {
  pushEvent("application_submitted", {
    application_type: data.applicationType,
    application_id: data.applicationId,
  });
}
